import { onlineManager } from "@tanstack/react-query";
import { useMainReact } from "../../main-react";

export function ErrorContent() {
  const { generalServerErrorMessage, generalOfflineErrorMessage } =
    useMainReact();

  return (
    <div className="saved-colors-loading-container">
      {onlineManager.isOnline
        ? generalServerErrorMessage
        : generalOfflineErrorMessage}
    </div>
  );
}
